/*
 * @Author: Cookie
 * @Date: 2020-07-13 13:50:35
 * @LastEditors: Lina
 * @LastEditTime: 2020-08-03 17:27:34
 * @Description: 
 */ 
import React, { Component } from 'react';
import _ from 'lodash';
import CrgtEvent from '../CrgtEvent';
import './index.scss';
import {eventMap} from '@/utils/constant'
import { track } from '@/wrappers';

@track
class Container extends Component {
  componentDidMount=()=>{
    const {openQuickApp} = CrgtEvent.parseUrlQuery(window.location.href);
    const isOpenQuickApp = !!openQuickApp;
    const {event} = this.props;
    if(isOpenQuickApp && event === 'openQuickApp') {
      this.onClick()
    }
  }
  onClick = (...args) => {
    const { event = 'doNothing', onClick, handleChangePage, router } = this.props;
    onClick && onClick(...args);
    let params = {};
    params = eventMap(this.props);
    const clickEvent = !_.isEmpty(event) ? (event !== 'navLink' ? function () {  CrgtEvent[`${event}`](params)}: ()=>{ handleChangePage && handleChangePage(router)}) :null;
    clickEvent()

  }
  render() {
    const { size='default', style,  } = this.props;
    let containerClass = size === 'default' ? 'fullContainer' : 'partContainer';
    return (
      <div className={containerClass} style={style}  onClick={this.onClick}>{this.props.children}</div>
    )
  }
}
export default Container
 